export enum KpiMetricTableType {
  WORKFLOW = 'Workflow',
  ACCEPTANCE = 'Acceptance',
  PERFORMANCE = 'Performance',
  COVER_RATIO = 'Cover Ratio',
  FINANCIAL_KPI = 'Financial Kpi',
  FINANCIAL_TABLE = 'Financial Table',
  PURCHASE_ORDER = 'Purchase Order',
}
